/*****************************************************************/
/*  docs used https://air-datepicker.com/docs                    */
/*                                                               */
/*****************************************************************/

import Component from './Component';
// import 'air-datepicker/dist/js/datepicker.js';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';

// import en from '../lib/datePickerLang';

import dateFormat from 'dateformat';
import jcf, { clearRange } from '../lib/jcf';

export default class SearchFilters extends Component {
  load() {
    this.initRangeRunCount = 0;

    this.initDisplayToggle();
    this.initReset();
    this.initClear();
    this.initRange();
    this.initConditionalLogic();
    this.initToggle();
    this.initDatePicker();
    this.initSyncDuplicateFields();
    this.initSelectAllToggle();
    this.initSort();

    super.load();
  }


  initDisplayToggle() {
    $('[data-toggle="display"]').on('click', (e) => {
      const allLayouts = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="display"]'))
        .map((element) => document.querySelector(element.getAttribute('data-target')));
      const target = document.querySelector(e.currentTarget.getAttribute('data-target'));

      $(allLayouts).not(target).fadeOut(400, () => {
        $(target).fadeIn();

        if (e.currentTarget.getAttribute('data-target') === '#map-layout') {
          $(window).trigger('map-visible');
          $('body').addClass('map-view');
        } else {
          $('body').removeClass('map-view');
        }
      });
    });

    $('[data-toggle="display"]').on('click', (e) => {
      const activeClass = `${e.currentTarget.classList[0]}--active`;

      $('[data-toggle="display"]').removeClass(activeClass);
      $(e.currentTarget).addClass(activeClass);
    });
  }


  initSelectAllToggle() {
    $('#selectAllToggle').on('click', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget.getAttribute('data-attributes')).each((e, target) => {
        if ($(target).val().length > 0) {
          $(target).val('');
        }
        else {
          var values = [];
          $(target).children().each(function (index, item) {
            values.push($(item).val())
          })
          $(target).val(values);
        }
        $(target).trigger('change');
        jcf.refresh(target);
      });
    });
  }


  initToggle() {
    // Bind opening/closing on button click (Mobile)
    $('[data-toggle="tray"], [data-toggle="fieldset"]').on('click', (e) => {
      const target = document.querySelector(e.currentTarget.getAttribute('data-target'));

      if (target) {
        e.preventDefault();

        setTimeout(() => {
          const openClass = `${target.classList[0]}--open`;
          target.classList.toggle(openClass);
          e.currentTarget.classList.toggle('active');

          if (e.currentTarget.getAttribute('data-toggle') === 'fieldset') {
            $('body')[target.classList.contains(openClass) ? 'addClass' : 'removeClass']('fieldset-open');
          } else {
            if (target.classList.contains(openClass)) {
              target.scrollTop = 0;
              $('body').addClass('tray-open');
            } else {
              $('body').removeClass('tray-open');
            }
          }
        }, 0);
      }
    });

    // Define an instance value to check if we're clicking inside the dropdown, which
    // we use when determining whether or not to close the fieldset when clicking outside
    // of the dropdown wrapper
    $('.search-filters__field-group__wrapper')
      .on('mousedown', (e) => {
        this.immediatedMouseDownInside = true
        this.mouseDownInside = true

        setTimeout(() => {
          this.immediatedMouseDownInside = false
        }, 0)
      })
      .on('mouseup', (e) => {
        this.immediatedMouseUpInside = true
        this.mouseUpInside = true

        setTimeout(() => {
          this.immediatedMouseUpInside = false
        }, 0)
      });

    $('body')
      .on('mousedown', (e) => {
        // If the event didn't originate inside a dropdown
        if (!this.immediatedMouseDownInside) {
          this.mouseDownInside = false
        }
      })
      .on('mouseup', () => {
        // If this event originated inside a dropdown
        if (this.immediatedMouseUpInside) {
          // After any other events, reset the mouseDownInside prop
          setTimeout(() => {
            this.mouseDownInside = false
          }, 0)
        }
      });

    // Close open fieldsets when clicking elsewhere on the body
    $('body').on('click', (e) => {
      // We check if the following is true:
      // 1. We haven't marked this event to have begun inside a dropdown (this.mouseDownInside)
      // 2. The original event is trusted. JCF triggers a 'click' event on it's real element wich is not trusted
      // 3. A fieldset is actually open...
      if (!this.mouseDownInside && e.originalEvent.isTrusted && $('body').hasClass('fieldset-open')) {
        $('body').removeClass('fieldset-open');
        $('[data-toggle="fieldset"]').each((i, element) => {
          const target = document.querySelector(element.getAttribute('data-target'));
          element.classList.remove('active');
          if (!$.contains(target.parentElement, e.target)) {
            target.classList.remove(`${target.classList[0]}--open`);
          }
        });
      }
    });

    //Display dropdown when clicked
    $('[data-toggle="fieldset"]').on('click', (e) => {
      $('[data-toggle="fieldset"]')
        .not(`[data-target="${e.currentTarget.getAttribute('data-target')}"]`)
        .each((i, element) => {
          const target = document.querySelector(element.getAttribute('data-target'));
          target.classList.remove(`${target.classList[0]}--open`);
          element.classList.remove('active');
        });

      // Set fieldset opener button and label values
    }).parent().find('input, select').on('change', (e) => {
      const target = e.currentTarget;
      const $target = $(e.currentTarget);
      const $group = $target.closest('.search-filters__field-group__wrapper');
      const $inputs = $group.find('input, select').not('[type="hidden"]');
      const $button = $group.children('[data-toggle="fieldset"]');
      const val = $target.val();
      let selectedCount = 1;

      if (Array.isArray(val) && val.length > 1) { // Multiselects will be an array
        selectedCount = val.length;
      }

      const hasValue = $inputs.toArray().reduce((prevValue, input) => {
        return prevValue || this.hasValue(input)
      }, false)

      if (hasValue) {
        // Set the selected data attribute so we can show the selected label
        $button.attr('data-selected', selectedCount);
      } else {
        $button.removeAttr('data-selected');
      }

      // Set the text to the selected option, assuming this is a select with only one option selected
      $button.data('default', $button.data('default') || $button.text());
      // Selected count will be 1 even if the array length is <=1
      if (selectedCount === 1 && Array.isArray(val) && val.length === 1 && $button.attr('data-target') !== '#fieldset-accessibility') {
        $button.text($(target).find(`option[value="${val[0]}"]`).text());

      } else if (target.name === 'free') {
        //disable ranged price
        const $range = $target.closest('.search-filters__field-group__wrapper').find('[type="range"]');
        $range.attr('disabled', target.checked);

        //Set open button text
        $button.text(target.checked ? 'Free' : $button.data('default'));
        jcf.refresh($range);

        if (!target.checked) {
          $range.trigger('change')
        }
      } else if (target.type === 'range') {

        const instance = jcf.getInstance(target);
        const min = parseInt(instance.values[0]);
        const max = parseInt(instance.values[1]);

        if (instance.minValue !== min || instance.maxValue !== max) {
          $button.text(`$${min} - $${instance.maxValue === max ? `${max}+` : max}`);
        } else {
          $button.text($button.data('default'));
        }
      } else if (target.getAttribute('type') === 'date') {

        const dates = [];

        $target.closest('.search-filters__field-group').find('[type="date"]').each((i, el) => {
          let date = $(el).data('date');

          // If we have a custom date
          if (el.value) {
            dates.push(el.value);
          }
        });

        if (dates.length === 1) {
          $button.text(`${dateFormat(dates[0], 'dd mmmm')} - End Date`);
        } else if (dates.length > 1) {
          $button.text(`${dateFormat(dates[0], 'dd mmmm')} - ${dateFormat(dates[1], 'dd mmmm yyyy')}`);

        } else {
          $button.text($button.data('default'));
        }
      } else if (target.tagName === 'SELECT' && !Array.isArray(val)) {

        $button.text(target.options[target.selectedIndex].text);
      } else {
        //$button.text($button.data('default'));
      }

      this.updateFilterCounts();

      this.doEvents('change', target);
    }).trigger('change');
  }


  initReset() {
    $('form').on('reset', (e) => {
      const selected = e.currentTarget.querySelectorAll('[data-selected]');
      const rangeElements = e.currentTarget.querySelectorAll('[type="range"]');
      $(e.currentTarget).find('[type="checkbox"]').map((i, element) => {
        element.checked = false;
      });

      if (rangeElements) {
        Array.prototype.slice.call(rangeElements).map(clearRange);
      }

      if (selected) {
        setTimeout(() => {
          //console.log($(selected).closest('.search-filters__field-group__wrapper').find('input, select'));
          $(selected).closest('.search-filters__field-group__wrapper').find('input, select').trigger('change');
        }, 20);
      }
    });
  }


  updateFilterCounts() {
    $('.search-filters__toggle')
      .attr('data-all-selected',
        $('[data-selected]:not([data-selected="0"])')
          .toArray()
          .map((el) => parseInt($(el).attr('data-selected')))
          .reduce((sum, count) => sum += count, 0)
      );
  }


  initClear() {
    $('[data-clear]').on('click', (e) => {
      const $target = $(e.currentTarget.getAttribute('data-clear')).each((e, target) => {
        $(target).val('');

        // If it's a range slider, we need to ensure some additional calculations are done
        if (target.type === 'range') {
          clearRange(target);
        }

        // If this is a text input (like the search bar)
        if (target.type === 'text') {
          target.focus();
        }

        // Reset the date fields to their default values
        if (target.hasAttribute('data-date')) {
          this.clearDatePicker(target);
        }

        $(target).trigger('change');
        jcf.refresh(target);
      });

      // Update datepickers on reset
      if($(e.currentTarget)?.find('[data-date]').length > 0) {
        $(e.currentTarget).find('[data-date]')?.datepicker('updateDates');
      }

      // Submit the form on clear
      //e.currentTarget.form.submit();
    });
  }


  initDatePicker() {
    let instance = [];

    // selector where calendar(s) should be created
    $('#search-filters-date').each((i, el) => {
      const $el = $(el);

      // convert string to date object
      // var dataEventStartDate = Date.parse($el.data('event-start-date')); // YYYY-MM-DD
      var formattedStartDate = $el.data('event-start-date'); // YYYY-MM-DD
      var formattedEndDate = $el.data('event-end-date'); // YYYY-MM-DD
      var dataEventStartDate = new Date(formattedStartDate);
      var dataEventEndDate = new Date(formattedEndDate);
      var hasEventDates = dateIsValid(dataEventStartDate) && dateIsValid(dataEventEndDate) && dataEventEndDate >= dataEventStartDate;

      // const startDate = hasEventDates ? formattedStartDate : "";
      // const endDate = hasEventDates ? formattedEndDate : "";

      instance[i] = new AirDatepicker(el, {
        // language: en,
        // startDate: startDate,
        // endDate: endDate,
        locale: localeEn,
        inline: true,
        range: true,
        dateFormat: "yyyy-MM-dd",
        //multipleDatesSeparator: ' - ',
        toggleSelected: false,
        navTitles: {
          days: 'MMMM yyyy',
          months: 'yyyy',
          years: 'yyyy1 - yyyy2',
        },
        onRenderCell: function (date, cellType) {
          // console.log('date', date);
          if (hasEventDates && date.cellType == 'day') {
            let thisDate = new Date(date.date);
            // console.log('thisDate', thisDate);
            if (thisDate >= dataEventStartDate && thisDate <= dataEventEndDate) {
              return {
                //todo: do we want to change the display of the cells?
                classes: 'air-datepicker-cell.-in-range- -in-range-'
              }
            }
          }
        },
        onSelect: ({ formattedDate, date, instance }) => {
          // console.log('instance', instance);
          // console.log('$el', $el);
          // change values in hidden from-date and to-date fields
          $el.closest('.search-filters__field-group').find('[type="date"]').map((i, el) => {
            if (typeof date[i] !== 'undefined') {
              $(el).data('date', date[i]);
              $(el).val(dateFormat(date[i], 'yyyy-mm-dd')); // format date for input
              $(el).trigger('change'); // trigger change event
            } else {
              $(el).data('date', null);
              $(el).val('');
              $(el).trigger('change');
            }
          });
        }
      })

      // convert date string into a date object
      // .data('datepicker').selectDate(
      //   el.closest('.search-filters__field-group')
      //     .find('[type="date"]')
      //     .toArray()
      //     .filter((el) => el.value)
      //     .map((el) => new Date(el.value))
      // );

      if (hasEventDates && $el.data('datepicker') !== undefined) {
        // TODO: check for errors here when sitesettings start and end dates set.
        // swap out moment.js to use js Date or intl internationlization.
        console.log('data DATEPICKER', $el.data('datepicker'));
        // console.log(dataEventStartDate.toDate());
        $el.data('datepicker').update('minDate', dataEventStartDate);
        $el.data('datepicker').update('maxDate', dataEventEndDate);
        console.log('instance[i]', instance[i]);
        instance[i].update('minDate', dataEventStartDate);
      }


      var selectedStartDate = new Date($el.data('selected-start-date')); // YYYY-MM-DD
      var selectedEndDate = new Date($el.data('selected-end-date')); // YYYY-MM-DD
      var hasSelectedDates = dateIsValid(selectedStartDate) && dateIsValid(selectedEndDate) && selectedEndDate >= selectedStartDate;

      if (hasSelectedDates && $el.data('datepicker') !== undefined) {
        console.log('data DATEPICKER', $el.data('datepicker'));
        $el.data('datepicker').selectDate([selectedStartDate, selectedEndDate]);
      }

    })
  }


  initRange() {
    var self = this;

    $('input[type="range"]').on('change', (e) => {
      const target = e.currentTarget;
      const values = jcf.getInstance(target).values;

      if (self.initRangeRunCount >= 2) {
        $(target).closest('.search-filters__field-group').find('[type="hidden"]').each((i, el) => {
          $(el).val(values[i]);
        });
      } else {
        self.initRangeRunCount++;
      }
    });
  }


  initConditionalLogic() {
    $('[data-toggle="filter"]').on('change', (e) => {
      const $target = $(e.currentTarget.getAttribute('data-target'));

      if (this.hasValue(e.currentTarget)) {
        $target.show();
      } else {
        $target.hide();
      }
    }).trigger('change');

    /*
    $('.search-filters__field-group--category select').on('change', (e) => {
    const date = document.getElementById('search-filters-date-wrapper');

    if (e.currentTarget.value.match(/events?/i)) {
    $(date).show();
    } else {
    $(date).hide();
    }
    }).trigger('change'); */
  }


  initSyncDuplicateFields() {
    const $groups = $('.search-filters__field-group');
    $groups.find('input, select').on('change', (e) => {
      const $duplicates = $groups.find(`[name="${e.currentTarget.name}"]`).not(e.currentTarget);

      $duplicates.val($(e.currentTarget).val());
      jcf.refresh($duplicates);
    });
  }


  getForm() {
    return $('.search-filters__wrapper').closest('form').get(0);
  }

  getFormValues() {
    return $(this.getForm()).serializeArray();
  }

  clearDatePicker(target) {
    $(target).closest('.search-filters__field-group').find('[type="date"]').each((i, el) => {
      $(el).data('date', null);
    });

    if ($(target).data('datepicker')) {
      $(target).data('datepicker').clear();
    }
  }

  hasValue(input) {
    const val = $(input).val();

    if (!Array.isArray(val)) {
      switch (input.type) {
        case 'checkbox':
          return input.checked;

        case 'range':
          const jcfInstance = jcf.getInstance(input);
          const defaults = [
            input.getAttribute('min'),
            input.getAttribute('max'),
          ].map(i => parseInt(i));

          if (jcfInstance) {
            return jcfInstance.values.reduce((sum, value, i) => {
              return sum || parseInt(value) !== defaults[i];
            }, false);
          }
          break;

        case 'date':
          const dates = [];
          $(input).closest('.search-filters__field-group').find('[type="date"]').each((i, el) => {
            const date = $(el).data('date');

            // If we have a custom date
            if (date && el.value) {
              dates.push(date);
            }
          });

          return dates.length > 1;
      }

      if (!isNaN(val)) { // This is a number
        return (parseFloat(val) > 0);
      }
    } else { // This must be a multiselect, return true if some values are selected
      return (val.length > 0);
    }

    // If we get here we'll just attempt to cast to bool
    return Boolean(val);
  }

  initSort() {
    $(".search-filters__sort").change(function () {
      $('#search-filters-sort').val($('#search-filters-sort-desktop').val());
      //$('#frmSearchFilter').submit();

      return false;
    });
  }
}


function dateIsValid(date) {
  return date instanceof Date && !isNaN(date);
}

// function dateIsAfter(date1, date2) {
//   return date1 > date2;
// }
